//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['step'],
    data: function data() {
        return {
            startIndex: 2,
            totalSteps: 11
        };
    },

    computed: {
        progressWidth: function progressWidth() {
            var width = void 0;

            if (this.step <= this.startIndex) {
                width = this.step * 50 / this.startIndex;
            } else {
                var numberSteps = this.totalSteps - this.startIndex;
                var index = this.step - this.startIndex;

                width = 50 + 50 / numberSteps * index;
            }
            return { width: width + '%' };
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/progress-movil.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/progress-movil.vue
// module chunks = 0 1 2